import { render } from "./mpesaPayments.vue?vue&type=template&id=6747704a&scoped=true"
import script from "./mpesaPayments.vue?vue&type=script&lang=js"
export * from "./mpesaPayments.vue?vue&type=script&lang=js"

import "./mpesaPayments.vue?vue&type=style&index=0&id=6747704a&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6747704a"]])

export default __exports__